/// <amd-module name="typeahead/core/userfeedbacktool/ui/DynamicFooter" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

const initial: string = `
    <span class = "dynamicTextFooter" style="color:#757575" role="group">
        <span class="helpful" style="width:auto; padding-top: 5.53846px;
            color:#757575">Are these suggestions helpful?
        </span>
        <a role="button" class="feedbackYes" href="#" onclick="return false;"
            style="width:auto;" >
            Yes
        </a>
        <a role="button" class="feedbackNo" href="#" onclick="return false;"
            style="width:auto;" >
            No
        </a>
    </span>
`;

const noHtml: string = `
    <span class = "dynamicTextFooter">
        <span class="sorryMessage" style="width:auto; padding-top: 5.53846px; color:#757575">
            We're sorry to hear that!
        </span>
        <a aria-label="Feedback" class="sorryButton" href="#" onclick="return false;"
            style="width:auto; color: #0065b8;" >
            Help us improve
        </a>
    </span>
`;

const yesHtml: string = `
    <span class = "dynamicTextFooter">
        <span class="thankingMessage" style="width:auto; padding-top: 5.53846px; color:#757575">
            Thank you for your feedback!
        </span>
    </span>
`;

export class DynamicFooter {
    constructor(
        private $dynamicFooter = $(initial),
        private $noElement = $(noHtml),
        private $yesElement = $(yesHtml),
    ) {
        this.$dynamicFooter.find("span.helpful").text(loc.areSuggestionsHelpfulMessage);
        this.$dynamicFooter.find(".feedbackYes").text(loc.agreeMessage);
        this.$dynamicFooter.find(".feedbackNo").text(loc.disagreeMessage);
        this.$noElement.find("span.sorryMessage").text(loc.regretMessage);
        this.$noElement.find("a.sorryButton").text(loc.helpImproveTypeaheadMessage);
        this.$yesElement.find("span.thankingMessage").text(loc.thankingUserMessage);
    }

    public getJQueryElement(): JQuery {
        return this.$dynamicFooter;
    }

    public getJQueryForNo(): JQuery {
        return this.$noElement;
    }

    public getJQueryForYes(): JQuery {
        return this.$yesElement;
    }
}
